import type { Model } from "@foundation/hydrate-model";

export const storyImageFromDaperModel: Model = {
  src: { dataPath: "baseUrl" },
  id: { dataPath: "id" },
  title: {
    dataPath: "title",
    transform: (extractedValue) => ({
      data: extractedValue ?? "",
    }),
  },
  type: { dataPath: ".", transform: () => ({ data: "image" }) },
  height: { dataPath: "origHeight" },
  origHeight: { dataPath: "origHeight" },
  origWidth: { dataPath: "origWidth" },
  width: { dataPath: "origWidth" },
};
